import { MarketingLayout } from "@/components/marketing/MarketingLayout";
import { HomeHero } from "@/components/marketing/HomeHero";
import { HomeSections } from "@/components/marketing/HomeSections";

export default function Landing() {
  return <MarketingLayout className="mk-home"><div data-testid="landing-page"><HomeHero /><HomeSections /></div></MarketingLayout>;
}